export function ThankYouScreen({ message }: { message: string }) {
  return <div className="form-screen">{message}</div>;
}
